import { ReactElement } from 'react'
import { Box } from '@mui/material'
import { EmptyState } from '@ui2/feedback'
import Results2CommentSection from '../Results2CommentSection'
import { Results2ListItem } from '../Results2ElementList'
import Results2PaneHeader from '../Results2PaneHeader'

interface Props {
  selectedItem?: Results2ListItem
  emptyMessage?: string
  comment?: string
  onCommentChange?: (value: string) => void
}

const Results2EmptyDetailPane = ({
  selectedItem,
  emptyMessage,
  comment,
  onCommentChange,
}: Props): ReactElement => (
  <Box sx={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
    <Results2PaneHeader
      title={selectedItem?.label ?? '-'}
      subtitle={
        selectedItem ? `${selectedItem.type} · ${selectedItem.qs}` : 'Bitte Element auswählen'
      }
    />
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 2,
      }}
    >
      {selectedItem ? <Results2CommentSection value={comment} onChange={onCommentChange} /> : null}
      {emptyMessage ? (
        <Box
          sx={{
            flex: 1,
            minHeight: 120,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <EmptyState sx={{ fontSize: 13 }}>{emptyMessage}</EmptyState>
        </Box>
      ) : null}
    </Box>
  </Box>
)

export default Results2EmptyDetailPane
